import { TmBaseError } from '@/core/error/tmBaseError'

export class TmInvalidValueError extends TmBaseError {
  public name = 'TmInvalidValueError'

  public actualValue: unknown = undefined

  public expectedValue: unknown = undefined

  constructor(message: string, actualValue?: unknown, expectedValue?: unknown) {
    super(message, {
      actualValue,
      expectedValue,
    })

    this.actualValue = actualValue
    this.expectedValue = expectedValue
  }
}
